// removed by extract-text-webpack-plugin
module.exports = {"hidden":"p-z_4","visuallyhidden":"_23CS2","hide-text":"_1-EXL","center":"_3s0-7","noprint":"_2C_kc","root":"_2G4Og"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/styles/svg/MastheadSearch.scss
 ** module id = 444
 ** module chunks = 0
 **/